import React from 'react';
import Tutorial from './Tutorial';
import useAppSelector from '../../app/redux/useAppSelector';
import {
  BEACON_POST_MODE_TOGGLE,
  BEACON_POST_OVERFLOW_MENU,
  BEACON_POST_TOPIC_BAR,
  BEACON_POST_VIEW_HISTORY,
  TUTORIAL_NAME_POST,
} from '../../constants/onboarding';
import beginning from '../../images/tutorials/post/beginning.png';
import end from '../../images/tutorials/post/end.png';
import history from '../../images/tutorials/post/history.gif';
import mention from '../../images/tutorials/post/mention.gif';
import organize from '../../images/tutorials/post/organize.gif';
import reading from '../../images/tutorials/post/reading.gif';
import getFirstName from '../../utils/text/getFirstName';

const PostTutorial = () => {
  const user = useAppSelector((state) => state.session.user);

  return (
    <Tutorial
      name={TUTORIAL_NAME_POST}
      steps={[
        {
          title: `Welcome, ${getFirstName(user.name) ?? ''}`,
          message:
            'This is a post, where you can edit, share, and collaborate in real time with your team.  We’d love to show you how it works!',
          imageUrl: beginning,
        },
        {
          title: 'Reading and editing',
          message:
            'Click the mode button to toggle between read and edit modes. You can only make changes to a post when editing.',
          beacons: [BEACON_POST_MODE_TOGGLE],
          imageUrl: reading,
        },
        {
          title: 'Organize your posts',
          message:
            'When in edit mode, you can add topics to a post, which will keep it organized for the right 👀 to see.',
          beacons: [BEACON_POST_TOPIC_BAR],
          imageUrl: organize,
        },
        {
          title: 'Smart mentions',
          message:
            'Mentions are references to users, posts, topics and third party tools that show details on hover. Paste in a link for automatic conversion.',
          imageUrl: mention,
        },
        {
          title: 'Look back in time',
          message:
            'Posts are saved automatically. You can easily revert to an older version with the history tool.',
          beacons: [BEACON_POST_OVERFLOW_MENU, BEACON_POST_VIEW_HISTORY],
          imageUrl: history,
        },
        {
          title: 'Great job!',
          message:
            'You are ready to begin writing. You can always bring back this tour in the help menu.',
          imageUrl: end,
        },
      ]}
    />
  );
};

export default PostTutorial;
